<template>
    <v-dialog
      v-model="showDialogGal"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card class="dialog-map">
        <v-toolbar dark color="black">
          <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
          <v-toolbar-title>{{currentGallery.title}}</v-toolbar-title>
          <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
          <v-btn icon dark @click="showDialogGal=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>          

        </v-toolbar>
<!--         <v-card-title class="headline head-map-dialog pa-0">
          <v-row justify="space-between" align="center" class="ma-0 pa-0">
            <v-col cols="2">
              
            </v-col>
            <v-col cols="8" class="white--text">
               {{currentGallery.title}}
            </v-col>
            <v-col cols="2" class="d-flex justify-end">
                <v-btn text color="white" @click="showDialogGal=false">X</v-btn>
            </v-col>
            
          </v-row>
        </v-card-title> -->


        <v-row class="slider-seo ma-0 pa-0">
            <v-col cols="12" class="pa-0 swiper-pos-off ">

            <div v-swiper:mySwiper="swiperOptions" class="">
              <div class="swiper-wrapper ">
                <div class="swiper-slide"  v-for="(slide, i) in currentGallery.images" :key="i" >
                            <v-row
                            class="ma-0 pa-0"
                              align="center"
                              justify="center"
                            >
                              <v-col class="ma-0 pa-0">{{slide.image}}
                                <v-img 
                                :src="`http://api.trcgagarinsky.ru/`+slide.image"
                                aspect-ratio="2.0"
                                contain
                                >

                                </v-img>


                                </v-col>
                            </v-row>
                </div>
              </div>
              <div class="swiper-pagination "></div>
              <div class="swiper-button-next d-flex justify-end">
                      <v-btn 
                      class="ma-2 btn-round-border-w" 
                      fab
                      outlined
                      x-large                            
                      color="#fff"
                      >
                        <v-icon light>mdi-chevron-right</v-icon>
                      </v-btn>
              </div>
              <div class="swiper-button-prev d-flex justify-start">
                      <v-btn 
                      class="ma-2 btn-round-border-w" 
                      fab
                      outlined
                      x-large                            
                      color="#fff"
                      >
                        <v-icon light>mdi-chevron-left</v-icon>
                      </v-btn>
              </div>
            </div>    

            </v-col>
          </v-row> 


      </v-card>
    </v-dialog>
  
</template>

<script>

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
/* import 'swiper/css/swiper.css' */
export default {
  name: 'SelectGalleryPhotoDialog',
  props: ['selectGallery','numStartSlide' ],
      components: {
        Swiper,
        SwiperSlide
        },
  directives: {
    swiper: directive
  },
  data: () => ({
        form: 14,
        swiperOptions: {
          centeredSlides: true,
          centerInsufficientSlides: true,
          normalizeSlideIndex: false,
        //  effect: 'fade',
          spaceBetween: 0,
          centeredSlides: true,
          loop: true,
          initialSlide: 0,
          autoplay: {
            delay: 6000,
            disableOnInteraction: false
          },
/*           pagination: {
            el: '.swiper-pagination',
            clickable: true
          }, */
          navigation: {
            nextEl: '.swiper-button-next',
          //  nextEl: '.arrowr-slider',
            prevEl: '.swiper-button-prev',
          //  prevEl: '.arrowl-slider'
          }
        },
  }),
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
        currentGallery: {
          get () {
            return this.$store.state.gallery.currentGallery;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setCurrentGallery', val)
          }
        },    
        gallery: {
          get () {
            return this.$store.state.gallery.gallery;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setGallery', val)
          }
        },    
        swiperd() {
        return this.$refs.mySwiper.swiper
        },
        showDialogGal: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.showDialogGal);
            return this.$store.state.app.showDialogGal;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setShowDialogGal', val)
          }
        },


  },
  methods:{
    resetSwiperDTimeout: function() {
      const vApp = this;
        setTimeout(() => { 
        if(DEBUG) console.log('update swiper SEO :>>',vApp.$refs );
        vApp.mySwiper.update();   
        
      // vApp.mySwiper.slideTo(vApp.numStartSlide, 200, false);
      }, 1500);
    },

  },
  beforeMount(){
        let vApp = this;
    vApp.swiperOptions.initialSlide = vApp.numStartSlide;
  },
  mounted() {
      // current swiper instance
    let vApp = this;
  //  vApp.swiperOptions.initialSlide = vApp.numStartSlide;
    vApp.$nextTick(function () {  
      if(DEBUG) console.log('Current Swiper Gallery instance object', this.mySwiper);
    //  vApp.mySwiper.slideTo(vApp.numStartSlide, 1000, false);
      vApp.resetSwiperDTimeout();
    });
    },
  beforeDestroy: function () {
      let vApp = this;
      if(DEBUG) console.log("Удаляем SWIPER Gallery");
      vApp.mySwiper.destroy();
  }   
};
</script>
<style scoped>
.swiper-pos{
  position: absolute;
}
.swiper-slider{
  
  height: 300px;
}
.slide-seo{
  background-position: center;
  width: 100%;
  height: 300px;
  
}
.swiper-container{
  width: 100%;
}
.slider-seo{
  
  width: 100%;
  
}

.dwnlayer-slider{
  position: absolute;
  bottom: 15px;
  left: 0;
  z-index: 202;
}
.uplayer-slider{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 201;
}
.swiper-button-prev:after, .swiper-button-next:after{
content: none;
}
.swiper-button-prev{
left: 5%;
}
.swiper-button-next{
right: 5%;
}

</style>